module.exports = __webpack_public_path__ + "img/travel-by-destination.2f71ae47.webp";